var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#50E2CF;}\n"),React.createElement("g",{"id":"Layer_2_1_","key":1}),React.createElement("g",{"id":"Layer_1_1_","key":2},React.createElement("g",null,[React.createElement("path",{"className":"st0","d":"M47.5,0C21.3,0,0,21.3,0,47.5S21.3,95,47.5,95S95,73.7,95,47.5S73.7,0,47.5,0z M47.5,89.2\n\t\t\tc-23,0-41.7-18.7-41.7-41.7S24.5,5.8,47.5,5.8s41.7,18.7,41.7,41.7S70.5,89.2,47.5,89.2z","key":0}),React.createElement("polygon",{"className":"st0","points":"41.5,56.3 27.2,42 22.1,47.1 41.5,66.5 74.7,33.3 69.5,28.2 \t\t","key":1})]))]);
}

Checkmark.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 95 95","style":{"enableBackground":"new 0 0 95 95"},"xmlSpace":"preserve"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
